import { each, filterL, go, isNil, mapL, rejectL, takeAll } from "fxjs/es";
import { CommonNS } from "../../../../../../Common/CommonNS.js";
export const selectEls = (self, ids) => {
  self._checkNoProcessingTask();
  const selector_controller = self._getSelectorControllerThrowable();
  each((id) => {
    if (!self._els.has(id)) {
      throw new Error(`해당 엘리먼트를 찾을 수 없습니다. (id: ${id})`);
    }
  })(ids);
  const old_selected_el_ids = self._selected_el_ids;
  const new_selected_el_ids = new Set(ids);
  const els = go(
    self._els.entries(),
    filterL(([id]) => new_selected_el_ids.has(id)),
    (entries) => new Map(entries)
  );
  const selected_els = go(
    new_selected_el_ids,
    rejectL((id) => old_selected_el_ids.has(id)),
    mapL((id) => self._els.get(id)),
    rejectL(isNil),
    takeAll
  );
  const unselected_els = go(
    old_selected_el_ids,
    rejectL((id) => new_selected_el_ids.has(id)),
    mapL((id) => self._els.get(id)),
    rejectL(isNil),
    takeAll
  );
  const new_selected_els = go(
    new_selected_el_ids,
    mapL((id) => self._els.get(id)),
    rejectL(isNil),
    takeAll
  );
  self._selected_el_ids = new_selected_el_ids;
  selector_controller.syncWith(els);
  CommonNS.UtilNS.tryNoop(() =>
    each((el) =>
      CommonNS.UtilNS.tryNoop(() =>
        el.wrapper_el.dispatchEvent(
          new CustomEvent("@mp/sticker-editor/select", {
            bubbles: true,
            cancelable: true,
            composed: false,
            detail: {
              el,
              selected_els: new_selected_els,
            },
          })
        )
      )
    )(selected_els)
  );
  CommonNS.UtilNS.tryNoop(() =>
    each((el) =>
      CommonNS.UtilNS.tryNoop(() =>
        el.wrapper_el.dispatchEvent(
          new CustomEvent("@mp/sticker-editor/unselect", {
            bubbles: true,
            cancelable: true,
            composed: false,
            detail: {
              el,
              selected_els: new_selected_els,
            },
          })
        )
      )
    )(unselected_els)
  );
};
